import PropTypes from 'prop-types'

export const FloatingActionButton = ({ onClick }) => (
  <button
    onClick={onClick}
    className="fixed top-6 left-4 sm:left-8 w-10 h-10 sm:w-12 sm:h-12 bg-dark-secondary hover:bg-dark-tertiary border border-dark-border hover:border-gray-700 text-gray-500 hover:text-gray-300 rounded-full shadow-xl flex items-center justify-center transition-all duration-200 z-40 focus:outline-none focus:ring-2 focus:ring-gray-400 focus:ring-offset-2 focus:ring-offset-gray-900"
    aria-label="Open menu"
  >
    <svg
      className="w-3.5 h-3.5 sm:w-6 sm:h-6"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
    </svg>
  </button>
)

FloatingActionButton.propTypes = {
  onClick: PropTypes.func.isRequired,
}
